<template>
	<div id="app" >
		<header>
			<div class="back flexJA flexFs">
				<div class="cursor flexJA" @click="goBack"><i class="el-icon-arrow-left iconfanhui"></i> <span>外设</span></div>
			</div>
		</header>
		<main>
			<router-view />
			<dts v-if="dtsData.status"></dts>
			<Upgrade v-if="Upgrade.status"></Upgrade>
			<NOTLINKED></NOTLINKED>
			<dialogDefault></dialogDefault>
			<NotConnected></NotConnected>
			<VersionLow v-if="VersionLowStatus"></VersionLow>
		</main>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	import dts from '@/components/dts'
	import Upgrade from '@/components/Upgrade'
	import NOTLINKED from '@/components/NOTLINKED'
	import dialogDefault from '@/components/dialogDefault'
	import NotConnected from '@/components/NotConnected'
	import VersionLow from '@/components/VersionLow'
	import * as pdfjsLib from 'pdfjs-dist/es5/build/pdf';
	import pdfWorker from 'pdfjs-dist/es5/build/pdf.worker.entry';
	export default {
		components: {
			dts,
			Upgrade,
			NOTLINKED,
			dialogDefault,
			NotConnected,
			VersionLow
		},
		data() {
			return {
				times: false,
				dialogInput: true,
				forwardListener: null
			}
		},
		computed: {
			...mapState({
				dtsData: (state) => state.dtsData,
				Upgrade: (state) => state.Upgrade,
				equipmentStatus: (state) => state.equipmentStatus,
				NOTLINKEDSTATUS: (state) => state.NOTLINKEDSTATUS,
				VersionLowStatus: (state) => state.VersionLowStatus,
			}),
		},
		created() {
			
			this.$store.dispatch('getConfig');
			let update = localStorage.getItem('update');
			// this.$store.commit('gotState', {key: 'NOTLINKEDSTATUS', data: true});
;			if(update) {
				console.log(update);
				this.$store.commit('gotState', {key: 'update', data: JSON.parse(update)});
			}
			if(localStorage.getItem('UpgradeData') && localStorage.getItem('UpgradeData') != -1) {
				window.LZPlugin.nativeCall("IAPBurner.dll","GetProgress",null).then(res=>{
					// 进度为100，就不弹出画面了。
					if(res.msg == 100) {
						console.log('进度为100，就不弹出升级界面面了')
						localStorage.removeItem('UpgradeData')
						this.$store.commit('setUpgrade', {status: false, progress: 0, dialogStatus: false});
					}else {
						this.$store.commit('gotState', {key: 'NOTLINKEDSTATUS', data: true});
						
						// let Progress = res.msg;
						// console.log('进度：', Progress)
						// setTimeout(e=>{
						// 	window.LZPlugin.nativeCall("IAPBurner.dll","GetProgress",null).then(res=>{
						// 		console.log('第一次获取进度：', Progress, '第二次获取进度：', res.msg )
						// 		if(res.msg == Progress) {
						// 			console.log('进度<100，隔500ms再取一次进度，如果两个进度相等，则说明后台没有升级，就弹出画面，让用户升级')
						// 			// 进度<100，就间隔500ms再取一次进度，如果两个进度相等，则说明后台没有升级，就弹出画面，让用户升级。
						// 			// this.$store.commit('setUpgrade', {status: true, progress: res.msg, dialogStatus: true});
						// 			this.$store.commit('gotState', {key: 'NOTLINKEDSTATUS', data: true});
						// 		}else {
						// 			console.log('进度<100，如果进度不等，则提示用户“升级中，请等待”，直到进度到100，才让用户点击进入里面的功能画面。')
						// 			// 如果进度不等，则提示用户“升级中，请等待”，直到进度到100，才让用户点击进入里面的功能画面。
						// 			this.$store.commit('setUpgrade', {status: true, progress: res.msg, dialogStatus: true, type: 1});
						// 		}
						// 	})
						// }, 1000)
					}
				})
			}
			
			// 检查 DTS 驱动是否完整安装，返回 code:0 表示完整安装，code:1 表示未安装或不完整
			window.LZPlugin.nativeCall("DtsInstall.dll","get_dts_status",null).then(res=>{
				console.log('DtsInstall.dll[get_dts_status]: ', res)
				if(res.code == 1) {
					localStorage.setItem('dts', -1);
					this.$store.commit('gotState', {key: 'dtsData', data: {status: true, dialogStatus: true}});
				}else {
					localStorage.setItem('dts', 1);
				}
			}).catch(err => {
				console.error('DtsInstall.dll[get_dts_status]: ', err)
			});
			
			pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;
			pdfjsLib.GlobalWorkerOptions.isEvalSupported = false;
			this.loadPdf('https://legion.jooneit.com/pdf/Y960.pdf');
		},
		methods: {
			goBack() {
				this.$router.go(-1);
			},
			async loadPdf(url) {
				try {
					const loadingTask = pdfjsLib.getDocument(url);
					const pdf = await loadingTask.promise;
					const pages = [];
					
					for (let i = 1; i <= pdf.numPages; i++) {
						const page = await pdf.getPage(i);
						const viewport = page.getViewport({ scale: 3 });
						const canvas = document.createElement('canvas');
						const context = canvas.getContext('2d');
						  
						canvas.width = viewport.width;
						canvas.height = viewport.height;
						await page.render({ canvasContext: context, viewport }).promise;
						pages.push(canvas.toDataURL());
					}
					
					this.$store.commit('gotState', {key: 'pdfPages', data: pages});
					// console.log(pages)
				} catch (error) {
					console.log(error)
					this.error = error.message;
				}
			},
			GetTest() {
				// // 获取用户体验改善计划开关
				// window.LZPlugin.nativeCall('Pbase.dll','GetRegConfig',{ Name: 'IsQuitUEPlan' }).then(console.log).catch(console.error);
				// // 获取客户端信息
				// window.LZPlugin.nativeCall('Pbase.dll','GetNativeInfo').then(console.log).catch(console.error);
				// // 获取MTM信息
				// window.LZPlugin.nativeCall('Phwcap.dll','GetMTMInfo').then(console.log).catch(console.error);
				// // 提供VIP PID设备的状态函数结果
				// window.LZPlugin.nativeCall('PluginOne.dll','GetDeviceStatus').then(console.log).catch(console.error);
				// 获取用户信息
				// window.LZPlugin.getUserInfo();
				// LUDP数据上报
				// window.LZPlugin.dataReport('testCategory', 'testAction', 'testLabel', { testParam1: 1, testParam2: 'test' });
				// 关闭窗口
				// window.LZPlugin.closeWindow()
			}
		}
	}
</script>

<style lang="scss">
	@import '@/assets/css/style.scss';

	.el-poppers {
		padding: 12px !important;
		background: #1e242b !important;
		box-shadow: 0 6px 16px 4px rgb(13 13 13 / 20%), 0 4px 8px 0 rgb(13 13 13 / 32%), 0 2px 3px -2px #0d0d0d !important;
		border: 1px solid rgba(234, 247, 255, .1) !important;
		line-height: 22px !important;
		border-radius: 1px !important;
		font-size: 12px !important;

		div {
			font-size: 12px !important;
			line-height: 1.4;
		}

		.popper__arrow::after {
			box-shadow: 0 6px 16px 4px rgb(13 13 13 / 20%), 0 4px 8px 0 rgb(13 13 13 / 32%), 0 2px 3px -2px #0d0d0d !important;
		}
	}
	
	.el-fade-in-linear-leave-active {
	  transition: all 0.8s !important; 
	}
	
	
	
	.custom-loading {
		background-color: transparent !important;
		
		.el-loading-spinner {
			display: flex;
			justify-content: center;
			align-items: center;
			
			.el-icon-loading {
				display: none !important;
			}
			
			.el-loading-text {
				padding: 10px 40px;
				font-size: 12px;
				border-radius: 2px;
				color: rgba(234, 247, 255, 0.8);
				background: rgba(30, 36, 43, 0.98);
				border: 1px solid rgba(234, 247, 255, 0.1);
				box-shadow: 0px 6px 16px 0px rgba(13, 13, 13, 0.2);


			}
		}
	}
	
	.custom-background {
		background: linear-gradient(180deg,#12161e,#1b2026 39.43%,#0e1014 74.8%,#121419) !important;
	}
	
	.customLoading {
		cursor: default;
		pointer-events: none;
		
		.el-switch {
			cursor: default;
			pointer-events: none;
			opacity: 0.6;
		}
		
		.slider {
			.el-slider__runway {
				cursor: default;
				pointer-events: none;
				background: rgba(43, 47, 54, 1) !important;
				
				.el-slider__button-wrapper {
					.el-slider__button {
						background: url('@/assets/images/26-1.svg') no-repeat !important;
						background-size: 23px 28.5px !important;
						border-radius: 0 !important;
						border: none !important;
						height: 100% !important;
						width: 26px !important;	
					}
				}
				
				.el-slider__bar {
					background: rgba(97, 102, 113, 0.6) !important;
				}
			}
		}
		
		.slider-v {
			.el-slider__runway {
				cursor: default;
				pointer-events: none;
				background: rgba(43, 47, 54, 1) !important;
				
				.el-slider__button-wrapper {
					opacity: 0.3;
				}
				
				.el-slider__bar {
					background: rgba(97, 102, 113, 0.6) !important;
				}
			}
		}
		
		.btn {
			cursor: default;
			pointer-events: none;
			color: rgba(234, 247, 255, 0.2) !important;
			border: 1px solid rgba(234, 247, 255, 0.2) !important;
		}
		
		.mode {
			.list {
				cursor: default;
				pointer-events: none;
				opacity: 0.6;
			}
		}
		
		.dialog-center {
			.tabs {
				div {
					cursor: default;
					pointer-events: none;
					color: rgba(234, 247, 255, 0.2) !important;
					border: 1px solid rgba(234, 247, 255, 0.2) !important;
				}
				
				.checked {
					cursor: default;
					pointer-events: none;
					border: 1px solid rgba(56, 110, 254, 0.5) !important;
					
					&::before {
						opacity: 0.5 !important;
						
					}
				}
			}
			
			.color {
				cursor: default;
				pointer-events: none;
				opacity: 0.5 !important;
			}
			
			.el-color-dropdown {
				cursor: default;
				pointer-events: none;
				opacity: 0.5 !important;
			}
		}
		
		.dialog-head {
			.tabs {
				opacity:  0.5;
				cursor: default;
				pointer-events: none;
			}
		}
	}
</style>